import React from 'react';
import { Link } from 'react-router-dom';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';

import { EadNode } from 'types';

import { GridLeftPanelItemProps } from '../grid-types';

import { trimLabel } from '../upper-panel/grid-upper-panel';
import { levelIcon } from '../grid-hooks/breadcrumbs-hook';

export function GridLeftPanelEADItem(props: GridLeftPanelItemProps) {
  const {
    rootArchivalAid,
    classes,
    item,
    level = 0,
    gridConfig = [],
    hierarchyPath = [],
    archivalAidLevel = 0,
  } = props;

  const gridEntityConfig =
    gridConfig[level > archivalAidLevel + 1 ? archivalAidLevel + 1 : level];

  const itemId = item?.id;

  const itemLink = itemId
    ? `${gridConfig[0].urlRoute}/${level}/${itemId}/ead`
    : '';
  const inHierarchyPath = hierarchyPath.some((i) => i.id === itemId);

  const items = (item as EadNode).children ?? [];

  const withSubItems = items.length > 0;
  const listItemClass = inHierarchyPath
    ? classes.listItemActive
    : classes.listItem;

  const Icon = levelIcon?.[item?.level] ?? gridEntityConfig?.icon;
  return (
    <>
      <Link to={itemLink} className={classes?.link}>
        <ListItem>
          {Icon && <Icon className={classes.icon} />}
          <ListItemText
            primary={trimLabel(item.title)}
            classes={{
              primary: listItemClass,
            }}
          />
          {items.length > 0 ? (
            inHierarchyPath ? (
              <ExpandLessIcon classes={{ root: listItemClass }} />
            ) : (
              <ExpandMoreIcon classes={{ root: listItemClass }} />
            )
          ) : null}
        </ListItem>
      </Link>
      {withSubItems && (
        <Collapse in={inHierarchyPath} timeout="auto" unmountOnExit>
          <List
            component="div"
            className={classes.nested}
            disablePadding
            dense={true}
            // subheader={
            //   <ListSubheader component="span" className={classes.subTitle}>
            //     {`EAD (${items.length})`}
            //   </ListSubheader>
            // }
          >
            {items.map((subItem) => {
              return (
                <GridLeftPanelEADItem
                  classes={classes}
                  key={subItem?.id}
                  item={subItem}
                  level={level + 1}
                  gridConfig={gridConfig}
                  rootArchivalAid={rootArchivalAid}
                  hierarchyPath={hierarchyPath}
                  GridLeftPanelItem={GridLeftPanelEADItem}
                />
              );
            })}
          </List>
        </Collapse>
      )}
    </>
  );
}
